import { render, staticRenderFns } from "./AutomationList.vue?vue&type=template&id=2a238bbf&scoped=true"
import script from "./AutomationList.vue?vue&type=script&lang=js"
export * from "./AutomationList.vue?vue&type=script&lang=js"
import style0 from "./AutomationList.vue?vue&type=style&index=0&id=2a238bbf&prod&scoped=true&lang=scss"
import style1 from "./AutomationList.vue?vue&type=style&index=1&id=2a238bbf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a238bbf",
  null
  
)

export default component.exports